import { Col, Row, Skeleton, Typography } from "antd";
import React from "react";
import RateStarSelect from "../commentFilter/RateStarSelect";

const { Text } = Typography;

type Props = {
  isLoading: boolean;
  stars: number;
  style?: React.CSSProperties | undefined;
  titleRate: string;
};

const styles = {
  star: {
    display: "flex",
    alignItems: "center",
  },
  text: {
    fontWeight: 700,
    fontSize: "14px",
  },
};

const ContentByStars = ({ stars }: { stars: number }) => {
  switch (stars) {
    case 0:
      return <></>;
    case 1:
      return <>Sản phẩm không phù hợp với tôi</>;
    case 2:
      return <>Không ấn tượng với sản phẩm</>;
    case 3:
      return <>Sản phẩm bình thường</>;
    case 4:
      return <>Hài lòng về sản phẩm</>;
    case 5:
      return <>Cực kỳ hài lòng về sản phẩm</>;
    default:
      return <></>;
  }
};

const StarRating = ({
  isLoading,
  stars = 0,
  style = { width: "100%" },
  titleRate,
}: Props) => {
  return (
    <div style={{ ...style }}>
      {isLoading ? (
        <Skeleton paragraph={{ rows: 0 }} />
      ) : (
        <Row gutter={[10, 6]} justify={"start"} align={"middle"}>
          <Col>
            <div style={{ ...styles.star }}>
              <RateStarSelect stars={stars} size={16} />
            </div>
          </Col>
          <Col>
            <Text style={{ ...styles.text }}>
              {/* <ContentByStars stars={stars} /> */}
              {titleRate}
            </Text>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default StarRating;
